module.exports = __webpack_public_path__ + "static/media/therapies-to-discuss-yellow-28.1117ab67.svg";